import React from 'react';
import classnames from 'classnames';
import { Icon } from '../Icon/Icon';

interface HeaderProps<T> {
  items: T[];
  expandedItems: T[];
  expandableItemsCount: number;
  onSetExpandedIndexes: (indexes: number[]) => void;
  expandable?: (data: T) => boolean;
}

export function ExpandableHeader<T>({
  items,
  expandedItems,
  expandableItemsCount,
  onSetExpandedIndexes,
  expandable,
}: HeaderProps<T>): JSX.Element {
  return (
    <th key="meta_fields" className={classnames('sortable-list__header sortable-list__header--expansion')}>
      <div
        className={classnames('sortable-list__expansion-indicator', {
          active: expandedItems.length >= expandableItemsCount,
        })}
        onClick={() =>
          onSetExpandedIndexes(
            expandedItems.length >= expandableItemsCount
              ? []
              : items
                  .filter((e) => {
                    if (expandable) {
                      return expandable(e);
                    }
                    return true;
                  })
                  .map((e) => items.indexOf(e))
          )
        }
      >
        <Icon name="arrow-triangle-right--sm" />
      </div>
    </th>
  );
}

interface CellProps<T> {
  row: T;
  expandedItems: T[];
  expandableItemsCount: number;
  onClick: () => void;
  expandable?: (data: T) => boolean;
  mutedColor?: boolean;
}

export function ExpandableCell<T>({
  row,
  expandedItems,
  expandableItemsCount,
  onClick,
  expandable,
  mutedColor,
}: CellProps<T>): JSX.Element | null {
  if (expandable?.(row)) {
    return (
      <td key="expansion_indicator" className="sortable-list__cell">
        <div
          className={classnames('sortable-list__expansion-indicator', {
            active: expandedItems.includes(row),
            'sortable-list__expansion-indicator--muted': mutedColor,
          })}
          onClick={onClick}
        >
          <Icon name="arrow-triangle-right--sm" />
        </div>
      </td>
    );
  }

  if (expandableItemsCount > 0) {
    return <td key="expansion_indicator" />;
  }

  return null;
}
